import { Formik } from 'formik'
import { ReactElement, useCallback } from 'react'
import { v4 } from 'uuid'
import { ICurrency } from '../types/types'
import { api } from '../utils/api'
import { useAddCurrency } from '../states/currencies-state'
import { FormikHelpers } from 'formik/dist/types'

interface FormErrors {
  name?: string
  code?: string
  form?: string
}

const INITIAL_VALUES: Partial<ICurrency> = {
  id: v4(),
}

const CurrencyForm = (): ReactElement => {
  const addCurrency = useAddCurrency()

  const onSubmit = useCallback(
    async (values, { setSubmitting, setErrors, resetForm }: FormikHelpers<any>) => {
      if (!values.name || !values.code) {
        setErrors({
          name: !values.name ? 'Name is required' : undefined,
          code: !values.code ? 'Codename is required' : undefined,
        })
        return
      }

      try {
        const { data, status, statusText } = await api.post('currency', values)
        if (status === 200 && data.currency) {
          addCurrency(data.currency)
          resetForm()
        }
      } catch (error) {
        setErrors({
          form: error.response.data.error,
        })
      }
    },
    [],
  )

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        // @ts-ignore
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="name"
            value={values.codename}
            className="input input-bordered w-full min-w-8 mb-4"
          />
          <label className="label">
            <span className="text-error">{errors?.name?.toString()}</span>
          </label>

          <input
            type="text"
            name="code"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Eg. USD"
            value={values.codename}
            className="input input-bordered w-full min-w-8 mb-4"
          />
          <label className="label">
            <span className="label-text-alt text-error">{errors?.code?.toString()}</span>
          </label>
          <button type="submit" className="btn btn-outline" disabled={isSubmitting}>
            Submit
          </button>
          <div>
            <span className="label-text-alt text-error">{errors?.form?.toString()}</span>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default CurrencyForm